import BrilliantlyEngineered from "../../../../assets/svg/double-quotes.svg";
const NZGregFarrier = ({ bg, slogan }) => {
  return (
    <>
      <div className={`pt-[10px] pb-[10px] bg-[${bg ? bg : "#f6f6f6"}]`}>
        <div className="md:max-w-[80%] max-w-full mx-auto py-[10px]">
          <div className="custom-container px-[30px] text-center">
            <h2 className="kuunari-bold text-[32px] text-[#383838] mb-[30px] text-center">
              Client Testimonials
            </h2>
            <div className="montserrat-bold text-[22px] lg:mb-[20px] sm:mb-[20px] text-[#AF8600] leading-[43px] mb-[10px] max-w-[1018px] mx-auto italic">
              {slogan || "“THIS IS HANDS DOWN THE MOST VERSATILE ATV I HAVE PURCHASED FOR THE FARM”"}
            </div>
            <div className="kuunari-bold text-[30] text-[25px] lg:mb-[20px] sm:mb-[20px] text-[#383838] leading-[68px] mb-[10px]">
              GREG FARRIER
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mt-[65px]">
              <div className="col-span-1">
                <div className="flex items-center justify-center">
                  <div className="text-[40px] leading-[0px] border-[3px] border-[#A8A6A6] rounded-full mb-[20px] !w-[70px] !h-[70px] flex items-center justify-center">
                    <img src={BrilliantlyEngineered} alt="" className="w-[30px]" />
                  </div>
                </div>
                <div className="montserrat-bold text-[#A8A6A6] text-[16px]">"Brilliantly Engineered"</div>
              </div>
              <div className="col-span-1">
                <div className="flex items-center justify-center">
                  <div className="text-[40px] leading-[0px] border-[3px] border-[#A8A6A6] rounded-full mb-[20px] !w-[70px] !h-[70px] flex items-center justify-center">
                    <img src={BrilliantlyEngineered} alt="" className="w-[30px]" />
                  </div>
                </div>
                <div className="montserrat-bold text-[#A8A6A6] text-[16px]">"Handles hills with ease"</div>
              </div>
              <div className="col-span-1">
                <div className="flex items-center justify-center">
                  <div className="text-[40px] leading-[0px] border-[3px] border-[#A8A6A6] rounded-full mb-[20px] !w-[70px] !h-[70px] flex items-center justify-center">
                    <img src={BrilliantlyEngineered} alt="" className="w-[30px]" />
                  </div>
                </div>
                <div className="montserrat-bold text-[#A8A6A6] text-[16px]">
                  "Looks and runs as reliably as a 1950's Land Rover"
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default NZGregFarrier;
